
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard/dashboard';
import OrderList from './components/OrderList/orderList';
import OrderDetails from './components/OrderList/orderDetails';
import AdminRoute from './components/AdminRoute';
import Login from './components/Login/login';
import UserList from './components/UserList/userList';
import UserDetails from './components/UserList/userDetails';
import UserWalletDetails from './components/ManageWallet/walletdetails';
import ScrapRateList from './components/ScrapRate/scrapRateList';
import UpdateScrapRate from './components/ScrapRate/updateScrapRate';
import OrderPage from './components/CreateOrder/createOrder';
import NotFound from './components/NotFound/notFound';
import Layout from './layout';
import RecentTransactions from './components/RecentTransactions/recentTransactions';
import SubAdminManager from './components/CreateSubadmin/createsubAdmin';
import ResetPassword from './components/PasswordChange/passwordChange';

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/login" element={<Login />} />

                <Route path="/admin" element={<Layout />}>
                    <Route
                        path="dashboard"
                        element={
                            <AdminRoute>
                                <Dashboard />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="getOrders"
                        element={
                            <AdminRoute>
                                <OrderList />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="createOrder"
                        element={
                            <AdminRoute>
                                <OrderPage />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="orderDetails/:id"
                        element={
                            <AdminRoute>
                                <OrderDetails />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="getUsers"
                        element={
                            <AdminRoute>
                                <UserList />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="userDetails/:id"
                        element={
                            <AdminRoute>
                                <UserDetails />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="wallet/:id"
                        element={
                            <AdminRoute>
                                <UserWalletDetails />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="getScrapRate"
                        element={
                            <AdminRoute>
                                <ScrapRateList />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="updateScrapRate"
                        element={
                            <AdminRoute>
                                <UpdateScrapRate />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="recentTransactions"
                        element={
                            <AdminRoute>
                                <RecentTransactions />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="createSubadmin"
                        element={
                            <AdminRoute>
                                <SubAdminManager />
                            </AdminRoute>
                        }
                    />
                     <Route
                        path="resetPassword"
                        element={
                            <AdminRoute>
                                <ResetPassword />
                            </AdminRoute>
                        }
                    />
                </Route>

                <Route path="*" element={<NotFound />} />
            </Routes>
        </Router>
    );
};

export default App;
